import { render, staticRenderFns } from "./WorkforceImpactSection.vue?vue&type=template&id=144f93a7&"
import script from "./WorkforceImpactSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkforceImpactSection.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports